function isValidFormat(input: string): boolean {
  const date_format_regex = /^\d{2}\/\d{2}\/\d{4}$/ //dd/mm/yyyy
  return date_format_regex.test(input)
}

const parseDateString: (date: string) => [Date, boolean] = (
  dateString: string,
) => {
  if (!isValidFormat(dateString)) {
    return [new Date(NaN), false] as const // Return an invalid date if format is wrong
  }
  const [day, month, year] = dateString.split("/").map(Number)
  const date: Date = new Date(year, month - 1, day)

  // Check if the date conversion did not result in an invalid date and the date components are correct
  const isValidDate =
    !isNaN(date.getTime()) &&
    date.getFullYear() === year &&
    date.getMonth() + 1 === month &&
    date.getDate() === day

  return [date, isValidDate] as const
}
export { parseDateString }
